module.exports = __webpack_public_path__ + "img/share_profit_m_grey.f992f2ef.svg";